import { useNavigate } from '@tanstack/react-router';
import { followLoginRedirect } from '@/lib/loginRedirect';

/** Gives login pages one way to leave after a successful login: to the validated `?redirect=` target, or home. */
export function useLoginRedirect() {
  const navigate = useNavigate();

  const followRedirect = () => followLoginRedirect(window.location, (path) => navigate({ href: path }));

  return { followRedirect };
}
